export default __webpack_public_path__ + "static/media/sort.5a29acd5.svg";